import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
import { request as defaultRequest } from "@octokit/request";
import btoa from "btoa-lite";

function deleteAuthorization(_x) {
  return _deleteAuthorization.apply(this, arguments);
}

function _deleteAuthorization() {
  _deleteAuthorization = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
    var request, auth;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            request = options.request ||
            /* istanbul ignore next: we always pass a custom request in tests */
            defaultRequest;
            auth = btoa("".concat(options.clientId, ":").concat(options.clientSecret));
            return _context.abrupt("return", request("DELETE /applications/{client_id}/grant", {
              headers: {
                authorization: "basic ".concat(auth)
              },
              client_id: options.clientId,
              access_token: options.token
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _deleteAuthorization.apply(this, arguments);
}

export { deleteAuthorization };